"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INCENTIVE_REDUCER = exports.OPTIMIZE_REDUCER = exports.BRAZE_NO_UPDATE_EVENTS = exports.TELEMETRY_EVENTS = exports.INCENTIVE_STATUS = exports.ORGS = exports.PRODUCTS = exports.OPTIMIZE_PRODUCTS = exports.CONTEXTS = exports.DISABLE_EXPERIMENT = void 0;
var DISABLE_EXPERIMENT = 'disableExperiment';
exports.DISABLE_EXPERIMENT = DISABLE_EXPERIMENT;
var CONTEXTS = {
  EXTERNAL: 'EXTERNAL',
  SECURE: 'SECURE',
  LOCAL: 'LOCAL'
};
exports.CONTEXTS = CONTEXTS;
var OPTIMIZE_PRODUCTS = {
  HELOC: 'HELOC'
};
exports.OPTIMIZE_PRODUCTS = OPTIMIZE_PRODUCTS;
var PRODUCTS = {
  HELOC: 'HELOC',
  STUDENT_LOAN_REFI: 'STUDENT_LOAN_REFI',
  CASHOUT_REFI: 'CASHOUT_REFI',
  CSP: 'CSP',
  AUCTION: 'MARKETPLACE_AUCTION',
  PERSONAL_LOAN: 'PL'
};
exports.PRODUCTS = PRODUCTS;
var ORGS = {
  FIGURE: 'FIGURE',
  PROVENANCE: 'PROVENANCE',
  ADNALES: 'ADNALES'
};
exports.ORGS = ORGS;
var INCENTIVE_STATUS = {
  PREOPEN: 'PREOPEN',
  OPEN: 'OPEN',
  NO_ACTIVE_INCENTIVE: 'NO_ACTIVE_INCENTIVE',
  INVALID_IDENTITY: 'INVALID_IDENTITY',
  INVALID_FULFILLMENT: 'INVALID_FULFILLMENT',
  INVALID_INCENTIVE: 'INVALID_INCENTIVE',
  UNKNOWN_ERROR: 'UNKNOWN_ERROR',
  VERIFY_ACCEPTED: 'VERIFY_ACCEPTED',
  EXISTING_INCENTIVE: 'EXISTING_INCENTIVE'
};
exports.INCENTIVE_STATUS = INCENTIVE_STATUS;
var TELEMETRY_EVENTS = {
  APP_STARTED: 'appStarted',
  HELOC_STARTED: 'helocStarted',
  HELOC_UW_PASS: 'helocUwPass',
  HELOC_OFFER_SELECTED: 'helocOfferSelected',
  HELOC_DISBURSEMENT_LINKED: 'helocDisbursementLinked',
  HELOC_MORE_PROFILE_ADDED: 'helocMoreProfileAdded',
  HELOC_ID_UPLOADED: 'helocIdUploaded'
};
exports.TELEMETRY_EVENTS = TELEMETRY_EVENTS;
var BRAZE_NO_UPDATE_EVENTS = [TELEMETRY_EVENTS.APP_STARTED, TELEMETRY_EVENTS.HELOC_STARTED];
exports.BRAZE_NO_UPDATE_EVENTS = BRAZE_NO_UPDATE_EVENTS;
var OPTIMIZE_REDUCER = 'optimizeReducer';
exports.OPTIMIZE_REDUCER = OPTIMIZE_REDUCER;
var INCENTIVE_REDUCER = 'incentiveReducer';
exports.INCENTIVE_REDUCER = INCENTIVE_REDUCER;